import { MouseEvent, SelectionType, TreeNode, TreeNodeProps } from "@mcleod/components";
import { MenuItem } from "@mcleod/core";

export interface MenuTreeNodeProps extends TreeNodeProps {
    menuItem: MenuItem;
    selectOnHover: boolean;
}

export class MenuTreeNode extends TreeNode {
    menuItem: MenuItem;
    protected isInitialized: boolean;
    constructor(props: Partial<MenuTreeNodeProps>) {
        super({
            fontSize: "small",
            fontBold: true,
            text: props.menuItem?.caption,
            allowSelect: false,
            rowBreak: false,
            fillRow: true,
            ...props
        });
        this.label.style.lineHeight = "16px";
        this.padding = 0;
        this.isInitialized = true;
        if (props.selectOnHover) {
            this.panel.addMouseEnterListener((event: MouseEvent) => this.tree.selectNode(this, SelectionType.SINGLE, event.domEvent));
            this.panel.addMouseLeaveListener((event: MouseEvent) => this.tree.selectNode(null, SelectionType.SINGLE, event.domEvent));
        }
    }
}
